// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__ZXK8h","filesListContainer":"PosDisputesFiles_filesListContainer__1ZlHG","filesButton":"PosDisputesFiles_filesButton__3aKrw"};